<template>
    <div>
        <span v-if="items.length === 0">-</span>
        <span v-else :content="items.join(', ')" v-tippy="{ theme: 'customTheme', placement: 'bottom', arrow: true, maxWidth: '420px' }">
            {{ visibleItems.join(', ') }}<span v-if="hiddenCount > 0" class="report-list-more">&nbsp;+{{ hiddenCount }}</span>
        </span>
    </div>
</template>

<script>
// Ile pozycji pokazujemy w komorce - reszta idzie w licznik i tooltip, zeby wiersz nie rozpychal tabeli.
const VISIBLE_ITEMS = 2;

export default {
    props: {
        // Pole wiersza z tablica pozycji do wyswietlenia (np. recipientsList).
        listField: {
            type: String,
            required: true
        }
    },
    data: function() {
        return {
            data: {}
        }
    },
    computed: {
        items() {
            return this.data[this.listField] || [];
        },
        visibleItems() {
            return this.items.slice(0, VISIBLE_ITEMS);
        },
        hiddenCount() {
            return Math.max(0, this.items.length - VISIBLE_ITEMS);
        }
    }
}
</script>

<style scoped>
.report-list-more {
    color: #346F8B;
    font-weight: 600;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduledReports/ReportListCell.vue